import { useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Dropdown, Menu, Space, message } from "antd";
import { useAppState, useAppDispatch } from "context";
import { setCreativeViewSize } from 'context/actions';

import "./SizeChanger.scss";

type ItemListType = {
  label: string;
  key: string;
  size: {
    width: number,
    height: number,
  };
}[]


const SizeChanger = () => {
  const dispatch = useAppDispatch();
  const { sizeViewList = [] as ItemListType, mainContent } = useAppState();
  const [selectedKey, setSelectedKey] = useState(['menu-3'])

  const onClick: MenuProps["onClick"] = (input) => {
    const index = parseInt(input.key.replace(/^\D+/g, ''), 10);
    const data = sizeViewList[index - 1];
    const fullscreen = index === 5 ;

    if (fullscreen){ // just change full screen
      dispatch(setCreativeViewSize({fullscreen}));
      return
    } else  { // this keeps old size when exiting fullscreen
      const updateData = {...data.size, fullscreen};
      dispatch(setCreativeViewSize(updateData));
      setSelectedKey([data.key])
    }

    if(mainContent){
      if(mainContent.clientWidth < data.size.width || mainContent.clientHeight < data.size.height) {
        message.warning('The size requested is larger then your current browser size');
      }
    }
  };

  const menu = (
    <Menu
      onClick={onClick}
      selectedKeys={selectedKey}
      items={sizeViewList}
    />
  );

  return (
    <div className={`size-change-wrapper`}>
      <Dropdown overlay={menu}>
        <a onClick={(e) => e.preventDefault()}>
          <Space>
            Change Size
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
    </div>
  );
};

export default SizeChanger;
